export default "__VITE_ASSET__BVU9Cono__";